import * as React from 'react';
import { ExperienceProvider } from '@origin-digital/features';
import { configAnalytics, navigation } from '@origin-digital/reporting-client';
import { isEmpty } from 'lodash';
import { MediaQueryProvider } from 'react-media-query-hoc';
import { signupData } from './appData';
import { PageContent } from './components/PageContent/PageContent';
import { mboxes } from './consts/mboxes';
import { CONFIG } from './consts/mediaQuery.js';
import { IHomepageStore } from './models/content.interfaces';

export const appName = 'origin-homepage';

export class App extends React.Component<{ store: IHomepageStore }, {}> {
  public componentDidMount() {
    configAnalytics({ appName });
    navigation('screen', {
      appName,
      currentUri: window.location.href,
      friendlyUri: 'originenergy:for-home',
    });
  }

  public render() {
    const { store } = this.props;
    const signUp = isEmpty(store.content.signup) ? signupData : store.content.signup;

    return (
      <ExperienceProvider mboxes={Object.values(mboxes)}>
        <MediaQueryProvider queries={CONFIG}>
          <PageContent store={store} signUp={signUp} />
        </MediaQueryProvider>
      </ExperienceProvider>
    );
  }
}
